<script>
  import Input from '@ui/pico/input.svelte';
  import { createEventDispatcher } from 'svelte';
  import Confirm from '../components/confirm.svelte';

  export let action = null;
  export let activeData = null;

  let formCount = null;
  let deleteConfirmDesc = null;

  $: form = (activeData?.form || []).reduce(
    (acc, item) => ({ ...acc, [item.name]: item.value }),
    {}
  );

  $: showEditSiteForm = action === 'showEditSiteForm';
  $: showDeleteSiteConfirm = action === 'showDeleteSiteConfirm';

  $: {
    if (showDeleteSiteConfirm) {
      formCount =
        activeData.numForms === 1
          ? `${activeData.numForms} form`
          : `${activeData.numForms} forms`;

      deleteConfirmDesc = `The site ${activeData.site} and its ${formCount}, powerups, data,
      and subscription will be deleted. This action is not recoverable.
      You can, however, create a fresh new site with the same domain.`;
    }
  }

  const dispatch = createEventDispatcher();
  function bubbleUpCustomEvent(evName) {
    return () => {
      dispatch(evName, { action, form });
    };
  }
</script>

{#if showEditSiteForm}
  <Confirm
    open
    title="Edit Site"
    cancelText="Cancel"
    confirmText="Update"
    on:cancel={bubbleUpCustomEvent('cancel')}
    on:confirm={bubbleUpCustomEvent('confirm')}
  >
    {#if activeData?.form && Array.isArray(activeData.form)}
      <div style="width:600px;">
        {#each activeData.form as input, idx}
          <Input
            name={input.name}
            type={input.type}
            placeholder={input.placeholder}
            bind:value={input.value}
          />
        {/each}
      </div>
    {/if}
  </Confirm>
{/if}

{#if showDeleteSiteConfirm}
  <Confirm
    open
    title="Are you sure you want to delete {activeData.site}?"
    desc={deleteConfirmDesc}
    cancelText="Cancel"
    confirmText="Delete the Site"
    on:cancel={bubbleUpCustomEvent('cancel')}
    on:confirm={bubbleUpCustomEvent('confirm')}
  />
{/if}
